'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button, Loader, TextField } from '@/shared/components/ui';
import type { UseNegociacaoSelfReturn } from '../hooks';
import type { CampoParametroSelf } from '../types';
import { campoPreenchido, campoValido, mascararValorCampo } from '../utils/parametrosCampos';
import { WizardFooter } from './WizardFooter';
import { WizardProgressHeader } from './WizardProgressHeader';
interface ParametrosScreenProps {
  vm: UseNegociacaoSelfReturn;
}
interface CampoParametroInputProps {
  campo: CampoParametroSelf;
  valor: string | boolean | undefined;
  mostrarErro: boolean;
  onChange: (valor: string | boolean) => void;
  onBlur: () => void;
}
const CampoParametroInput = t0 => {
  const $ = _c(37);
  const {
    campo,
    valor,
    mostrarErro,
    onChange,
    onBlur
  } = t0;
  if (campo.tipo === "BOOLEAN") {
    const simMarcado = valor === true;
    const naoMarcado = valor === false;
    const t1 = `campo-label-${campo.key}`;
    const t2 = naoMarcado ? "brand-secondary" : "neutral-secondary";
    const t3 = naoMarcado ? "border-brand-600 border border-solid" : "";
    let t4;
    if ($[0] !== onChange) {
      t4 = () => onChange(false);
      $[0] = onChange;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== naoMarcado || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
      t5 = <Button size="small" variant={t2} className={t3} aria-pressed={naoMarcado} onClick={t4}>Não</Button>;
      $[2] = naoMarcado;
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const t6 = simMarcado ? "brand-secondary" : "neutral-secondary";
    const t7 = simMarcado ? "border-brand-600 border border-solid" : "";
    let t8;
    if ($[7] !== onChange) {
      t8 = () => onChange(true);
      $[7] = onChange;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    let t9;
    if ($[9] !== simMarcado || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
      t9 = <Button size="small" variant={t6} className={t7} aria-pressed={simMarcado} onClick={t8}>Sim</Button>;
      $[9] = simMarcado;
      $[10] = t6;
      $[11] = t7;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t1 || $[15] !== t5 || $[16] !== t9) {
      t10 = <div className="mt-1 flex gap-2" role="group" aria-labelledby={t1}>{t5}{t9}</div>;
      $[14] = t1;
      $[15] = t5;
      $[16] = t9;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    return t10;
  }
  const mensagemErro = campoPreenchido(campo, valor) ? "Verifique o formato do valor informado" : "Preencha este campo para continuar";
  const t1 = mostrarErro ? mensagemErro : undefined;
  let t2;
  if ($[18] !== campo.prefixo) {
    t2 = campo.prefixo ? <span className="text-sm text-neutral-500">{campo.prefixo}</span> : undefined;
    $[18] = campo.prefixo;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== campo.sufixo) {
    t3 = campo.sufixo ? <span className="text-sm text-neutral-500">{campo.sufixo}</span> : undefined;
    $[20] = campo.sufixo;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  const t4 = typeof valor === "string" ? valor : "";
  const t5 = campo.placeholder ?? undefined;
  let t6;
  if ($[22] !== campo || $[23] !== onChange) {
    t6 = event => onChange(mascararValorCampo(campo, event.target.value));
    $[22] = campo;
    $[23] = onChange;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== campo.key || $[26] !== onBlur || $[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
    t7 = <TextField.Input id={campo.key} value={t4} placeholder={t5} onChange={t6} onBlur={onBlur} />;
    $[25] = campo.key;
    $[26] = onBlur;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== mostrarErro || $[32] !== t1 || $[33] !== t2 || $[34] !== t3 || $[35] !== t7) {
    t8 = <TextField className="w-full" error={mostrarErro} helpText={t1} icon={t2} iconRight={t3}>{t7}</TextField>;
    $[31] = mostrarErro;
    $[32] = t1;
    $[33] = t2;
    $[34] = t3;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
};
export const ParametrosScreen = t0 => {
  const $ = _c(23);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [camposTocados, setCamposTocados] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = key => setCamposTocados(atual => ({
      ...atual,
      [key]: true
    }));
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const marcarTocado = t2;
  let t3;
  if ($[2] !== vm.wizardSteps) {
    t3 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[2] = vm.wizardSteps;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-2"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[30px]">Quais os limites que a Lexi deve respeitar?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed">Suas respostas definem até onde a Lexi pode ir em cada negociação.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== vm.carregandoCampos) {
    t5 = vm.carregandoCampos && <div className="flex items-center gap-3 py-8"><Loader size="medium" /><span className="text-label-muted text-sm">Carregando os parâmetros...</span></div>;
    $[5] = vm.carregandoCampos;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== camposTocados || $[8] !== vm) {
    t6 = !vm.carregandoCampos && vm.camposObjetivo.map(campo => {
      const valor = vm.valoresParametros[campo.key];
      const mostrarErro = Boolean(camposTocados[campo.key]) && !campoValido(campo, valor);
      return <div key={campo.key} className="flex w-full flex-col gap-2"><label id={`campo-label-${campo.key}`} htmlFor={campo.tipo === "BOOLEAN" ? undefined : campo.key} className="text-heading-dark text-base font-semibold">{campo.label}</label>{campo.helper && <span className="text-label-muted text-sm">{campo.helper}</span>}<CampoParametroInput campo={campo} valor={valor} mostrarErro={mostrarErro} onChange={novoValor => vm.definirValorParametro(campo.key, novoValor)} onBlur={() => marcarTocado(campo.key)} /></div>;
    });
    $[7] = camposTocados;
    $[8] = vm;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-16"><div className="grid w-full max-w-[1280px] grid-cols-1 gap-10 lg:grid-cols-[minmax(260px,1fr)_minmax(380px,1.6fr)] lg:gap-20">{t4}<div className="flex w-full max-w-[580px] flex-col gap-9">{t5}{t6}</div></div></div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== vm) {
    t8 = () => vm.goTo("perfil");
    $[13] = vm;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = !vm.podeAvancarParametrosStep || vm.carregandoCampos;
  let t10;
  if ($[15] !== t8 || $[16] !== t9 || $[17] !== vm.criarAgente) {
    t10 = <WizardFooter onVoltar={t8} onAvancar={vm.criarAgente} avancarDisabled={t9} />;
    $[15] = t8;
    $[16] = t9;
    $[17] = vm.criarAgente;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t7) {
    t11 = <div className="flex min-h-screen w-full flex-col bg-white">{t3}{t7}{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};